import { ObjectSchema, object, string } from 'yup';
import { ErrorMessage } from '../enums';
import { AgentFormValues } from '../types/form/agent';

export const agentSchema: ObjectSchema<AgentFormValues> = object({
  agentCode: string()
    .required(ErrorMessage.Required)
    .min(5, ErrorMessage.MinLength)
    .max(10, ErrorMessage.MaxLength)
    .matches(/^[a-zA-Z0-9]+$/, ErrorMessage.Required),
});
